export default __webpack_public_path__ + "images/b97e1e303b56e34053be8bba7a7106c0.png";